export default {
  addRemoveFilters: "Add/remove filters",
  close: "Close",
  collapsePanel: "Collapse panel",
  expandPanel: "Expand panel",
  goBack: "Go back",
  discard: "Discard",
  goBackToPageView: "Go back to the page view",
  goBackToComparisonPage: "Go back comparison page",
  goBackToProjectInput: "Go back to the project view",
  goBackToProjectView: "Go back to the projects list",
  edit: "Edit",
  loadReport: "Load report",
  enable: "Enable",
  disable: "Disable",
  resendInvite: "Resend invite",
  configureWidget: "Configure widget",
  removeWidget: "Remove widget",
  removeAddedWidget: (widgetTitle: string) => `Remove '${widgetTitle}'`,
  cancelPageCreation: "Cancel page creation",
  cancelUpdatingTemplate: "Cancel updating template",
  csvExport: "Export data to CSV",
  createPage: "Create page",
  makePublic: "Make Public",
  cleanSavedCitiesAndZip: "Clean saved cities and zips",
  deleteTemplate: "Delete the template",
  exportToPdf: "Export to PDF",
  toggleColumns: "Toggle table columns",
  removeAccess: "Remove access",
};
